import React, { useState, useEffect } from 'react'
import { Modal, Row, Col, Input, Button, Form } from 'antd';
import { translate } from 'react-i18next'

const ModalUpload = ({title, show, dataFile, t, handleCancel, preview, onFinish}) => {
    const [form] = Form.useForm();
    const [description, setDescription] = useState("")
    const [filename, setFilename] = useState("")
    
    const handleChange = (e) => {
        switch (e.target.name) {
            case "filename":
                setFilename(e.target.value)
                return false
            case "description":
                setDescription(e.target.value)
                return false;
            default:
                return;
        }
        
    } 

   useEffect(() => {
    form.setFieldsValue({
        filename: dataFile.name,
        description: '',
        preview: preview,
        file: dataFile.originFileObj,
       
    })
   }, [form , preview, dataFile.originFileObj, dataFile.name])

   
  
 
    return (
        <>
            <Modal
                title={title}
                visible={show}
                onCancel={handleCancel}
                destroyOnClose={true}
                
                footer={[
                    <Button form="modal-reservation-form" key="submit" htmlType="submit" className="btn-submit-reservation-vroom" >
                        {t("lobby_modal.OK")}
                    </Button>,
                    <Button key="back" className="btn-cancel-join-vroom"  onClick={handleCancel}>
                        {t("lobby_modal.cancel")}
                    </Button>
                ]}
            >
                <Row className="modal-input-join-vroom">
                    <Col span={24}>
                        <Form
                            form={form}
                            name="modal-reservation-form"
                            onFinish={onFinish}
                        >
                            <Form.Item name="preview" style={{display: 'none'}}>
                                <Input name="preview" />
                            </Form.Item>
                            <Form.Item name="file">
                            {/* eslint-disable-next-line */}
                                <img name="file" src={preview}  width="60%" height="60%" style={styles.img} />
                            </Form.Item>
                            <Form.Item name="filename">
                                <Input name="filename" value={filename} onChange={(e) => handleChange(e)} />
                                
                            </Form.Item>
                            <Form.Item name="description">
                                <Input name="description" value={description} onChange={(e) => handleChange(e)} placeholder={"File Description"} />
                            </Form.Item>
                        </Form>
                        
                        
                        
                    </Col>
                </Row>
            </Modal>
        </>
    )
}

const styles = {
    img: {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        width: "50%"
    }
}

export default translate()(ModalUpload)